import styled from '@emotion/styled/macro';

export const LayoutWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${props => props.theme.widths.containerMaxWidth};
    margin: 0 auto;
    height: 100%;

    @media (max-width: ${props => props.theme.widths.containerMaxWidth}) {
        max-width: 100%;
    }
`;

export const WelcomeMessage = styled.div`
    margin: ${props => `0  auto ${props.theme.spacing.large}`};
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.medium};
`;

export const Name = styled.span`
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    text-transform: capitalize;
`;

export const Footer = styled.div`
    text-align: center;
    max-width: ${props => props.theme.widths.containerMaxWidth};
    font-size: ${props => props.theme.fontSize.xsmall};
    padding: 16px;
`;
